import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IOnboardingGuideStep } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';

@Component({
    selector: 'fi-todo-editor-guide-card',
    templateUrl: './fi-todo-editor-guide-card.component.html',
    styleUrls: ['./fi-todo-editor-guide-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-todo-editor-guide-card' },
    standalone: false,
})
export class FiTodoEditorGuideCardComponent {
    protected readonly guideSteps: IOnboardingGuideStep[] = [
        {
            Name: 'todo_list.list_name_guide',
            Description: 'todo_list.list_name_guide_description',
        },
        {
            Name: 'todo_list.add_items',
            Description: 'todo_list.add_items_guide_description',
        },
        {
            Name: 'common.sharing_selection',
            Description: 'todo_list.sharing_selection_guide_description',
        },
    ];
}
